<div class="item-preview-defaults clr-wrapper">
    <preview-field *ngFor="let field of previewFields; trackBy: trackByVal">
        <preview-field_label>{{ field.label }}</preview-field_label>
        <preview-field_val>{{ field.val }}</preview-field_val>
    </preview-field>
</div>

